/**
 * Tilled Internal API
 * Tilled Internal API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CardCheckoutMethodBreakdown } from './cardCheckoutMethodBreakdown';
import { OnboardingAddress } from './onboardingAddress';
import { BLEBankAccount } from './bLEBankAccount';
import { ProcessingVolume } from './processingVolume';
import { PatriotActDetails } from './patriotActDetails';
import { PrincipalCreateParams } from './principalCreateParams';


export interface OnboardingLegalEntity { 
    /**
     * Registered legal address of the business.
     */
    address: OnboardingAddress;
    /**
     * Banking details for the business\'s payouts.
     */
    bank_account: BLEBankAccount;
    /**
     * The date that any previous business bankruptcies were filed in YYY-MM-DD format. Required if `previous_bankruptcy` is `true` and `personal_file_date` not provided.
     */
    business_file_date?: string;
    /**
     * The method by which the business accepts card payments. The total value of all the methods must equal 100.
     */
    card_checkout_method_breakdown: CardCheckoutMethodBreakdown;
    /**
     * The date when the business was incorporated in YYY-MM-DD format.
     */
    date_of_incorporation: string;
    /**
     * The number of days billed prior to goods being shipped.
     */
    days_billed_prior_to_shipment?: number;
    /**
     * The merchant\'s trade name or Doing Business As Name (e.g. \"ACME\"), if different from the `legal_name`.
     */
    dba_name?: string;
    /**
     * Required if the merchant has processed credit cards before. If left blank, that indicates that the merchant did not process cards before.
     */
    existing_processor_name?: string;
    /**
     * Registered legal business name (e.g. \"ACME Corporation\").
     */
    legal_name: string;
    /**
     * The 4-digit merchant category code for the business. MCCs are used to classify businesses based on the goods or services they provide. \"0742\" : \"Veterinary Services\", \"0780\" : \"Landscaping Services\", \"1520\" : \"General Contractors\", \"1711\" : \"Heating, Plumbing, A/C Contractors\", \"1731\" : \"Electrical Contractors\", \"1740\" : \"Masonry, Stonework, and Plaster Contractors\", \"1750\" : \"Carpentry Contractors\", \"1761\" : \"Roofing/Siding, Sheet Metal Contractors\", \"1771\" : \"Concrete Work Contractors\", \"1799\" : \"Special Trade Services\", \"4119\" : \"Ambulance Services\", \"4121\" : \"Taxicabs/Limousines\", \"4214\" : \"Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services\", \"4816\" : \"Computer Network Services\", \"4900\" : \"Utilities\", \"5044\" : \"Photographic, Photocopy, Microfilm Equipment, and Supplies\", \"5399\" : \"Miscellaneous General Merchandise\", \"5411\" : \"Grocery Stores, Supermarkets\", \"5499\" : \"Miscellaneous Food Stores - Convenience Stores and Specialty Markets\", \"5811\" : \"Caterers\", \"5812\" : \"Eating Places, Restaurants\", \"5814\" : \"Fast Food Restaurants\", \"5965\" : \"Direct Marketing - Combination Catalog and Retail Merchant\", \"5970\" : \"Artists Supply and Craft Shops\", \"6513\" : \"Real Estate Agents and Managers - Rentals\", \"7230\" : \"Barber and Beauty Shops\", \"7299\" : \"Miscellaneous General Services\", \"7349\" : \"Cleaning and Maintenance\", \"7372\" : \"Computer Programming\", \"7379\" : \"Computer Repair\", \"7392\" : \"Consulting, Public Relations\", \"7523\" : \"Parking Lots, Garages\", \"7542\" : \"Car Washes\", \"7699\" : \"Miscellaneous Repair Shops\", \"7922\" : \"Theatrical Ticket Agencies\", \"7999\" : \"Miscellaneous Recreation Services\", \"8011\" : \"Doctors\", \"8021\" : \"Dentists, Orthodontists\", \"8031\" : \"Osteopaths\", \"8041\" : \"Chiropractors\", \"8042\" : \"Optometrists, Ophthalmologist\", \"8043\" : \"Opticians, Eyeglasses\", \"8049\" : \"Chiropodists, Podiatrists\", \"8050\" : \"Nursing/Personal Care\", \"8099\" : \"Medical Services\", \"8111\" : \"Legal Services, Attorneys\", \"8211\" : \"Elementary, Secondary Schools\", \"8220\" : \"Colleges, Universities\", \"8249\" : \"Vocational/Trade Schools\", \"8299\" : \"Educational Services\", \"8351\" : \"Child Care Services\", \"8398\" : \"Charitable and Social Service Organizations - Fundraising\", \"8661\" : \"Religious Organizations\", \"8699\" : \"Membership Organizations\", \"8931\" : \"Accounting/Bookkeeping Services\", \"8999\" : \"Professional Services\"
     */
    mcc: OnboardingLegalEntity.MccEnum;
    /**
     * Information required by the Patriot Act in the form of a business license or articles of incorporation.
     */
    patriot_act_details: PatriotActDetails;
    /**
     * Percentage of business-to-business (B2B) that the business conducts
     */
    percent_business_to_business: number;
    /**
     * The date that any previous personal bankruptcies were filed in YYY-MM-DD format. Required if `previous_bankruptcy` is `true` and `business_file_date` not provided.
     */
    personal_file_date?: string;
    /**
     * Indicates whether the business or an individual has filed for bankruptcy before.
     */
    previous_bankruptcy: boolean;
    /**
     * Array of Principals (ie Business Owners).
     */
    principals: Array<PrincipalCreateParams>;
    /**
     * An estimate of the processing volume of the business.
     */
    processing_volume: ProcessingVolume;
    /**
     * Description of the product sold by, or service provided by, the business.
     */
    product_description: string;
    /**
     * Whether or not the merchant wants to receive 1099K tax documents via email. If false, they will receive them by mail. Default is `false`.
     */
    receive_1099k_via_email: boolean;
    /**
     * Region for the merchant account
     */
    region: OnboardingLegalEntity.RegionEnum;
    /**
     * Provides information about a payment that customers see on their statements. Concatenated with the prefix (shortened descriptor) or statement descriptor that’s set on the account to form the complete statement descriptor. Maximum 20 characters for the concatenated descriptor.
     */
    statement_descriptor: string;
    /**
     * The category identifying the legal structure of the legal entity.
     */
    structure: OnboardingLegalEntity.StructureEnum;
    /**
     * Publicly available email address for sending support issues to.
     */
    support_email?: string;
    /**
     * Customer support phone number of the business. Cannot contain special characters.
     */
    support_phone: string;
    /**
     * The company\'s tax ID number (TIN)
     */
    tax_id_number: string;
    /**
     * The business\'s publicly available website.
     */
    website?: string;
}
export namespace OnboardingLegalEntity {
    export type MccEnum = '0742' | '0780' | '1520' | '1711' | '1731' | '1740' | '1750' | '1761' | '1771' | '1799' | '4119' | '4121' | '4214' | '4816' | '4900' | '5044' | '5399' | '5411' | '5499' | '5811' | '5812' | '5814' | '5965' | '5970' | '6513' | '7230' | '7299' | '7349' | '7372' | '7379' | '7392' | '7523' | '7542' | '7699' | '7922' | '7999' | '8011' | '8021' | '8031' | '8041' | '8042' | '8043' | '8049' | '8050' | '8099' | '8111' | '8211' | '8220' | '8249' | '8299' | '8351' | '8398' | '8661' | '8699' | '8931' | '8999';
    export const MccEnum = {
        _0742: '0742' as MccEnum,
        _0780: '0780' as MccEnum,
        _1520: '1520' as MccEnum,
        _1711: '1711' as MccEnum,
        _1731: '1731' as MccEnum,
        _1740: '1740' as MccEnum,
        _1750: '1750' as MccEnum,
        _1761: '1761' as MccEnum,
        _1771: '1771' as MccEnum,
        _1799: '1799' as MccEnum,
        _4119: '4119' as MccEnum,
        _4121: '4121' as MccEnum,
        _4214: '4214' as MccEnum,
        _4816: '4816' as MccEnum,
        _4900: '4900' as MccEnum,
        _5044: '5044' as MccEnum,
        _5399: '5399' as MccEnum,
        _5411: '5411' as MccEnum,
        _5499: '5499' as MccEnum,
        _5811: '5811' as MccEnum,
        _5812: '5812' as MccEnum,
        _5814: '5814' as MccEnum,
        _5965: '5965' as MccEnum,
        _5970: '5970' as MccEnum,
        _6513: '6513' as MccEnum,
        _7230: '7230' as MccEnum,
        _7299: '7299' as MccEnum,
        _7349: '7349' as MccEnum,
        _7372: '7372' as MccEnum,
        _7379: '7379' as MccEnum,
        _7392: '7392' as MccEnum,
        _7523: '7523' as MccEnum,
        _7542: '7542' as MccEnum,
        _7699: '7699' as MccEnum,
        _7922: '7922' as MccEnum,
        _7999: '7999' as MccEnum,
        _8011: '8011' as MccEnum,
        _8021: '8021' as MccEnum,
        _8031: '8031' as MccEnum,
        _8041: '8041' as MccEnum,
        _8042: '8042' as MccEnum,
        _8043: '8043' as MccEnum,
        _8049: '8049' as MccEnum,
        _8050: '8050' as MccEnum,
        _8099: '8099' as MccEnum,
        _8111: '8111' as MccEnum,
        _8211: '8211' as MccEnum,
        _8220: '8220' as MccEnum,
        _8249: '8249' as MccEnum,
        _8299: '8299' as MccEnum,
        _8351: '8351' as MccEnum,
        _8398: '8398' as MccEnum,
        _8661: '8661' as MccEnum,
        _8699: '8699' as MccEnum,
        _8931: '8931' as MccEnum,
        _8999: '8999' as MccEnum
    };
    export type RegionEnum = 'US' | 'CA';
    export const RegionEnum = {
        US: 'US' as RegionEnum,
        CA: 'CA' as RegionEnum
    };
    export type StructureEnum = 'charity' | 'community_interest_company' | 'corporation' | 'government' | 'limited' | 'limited_liability_company' | 'limited_liability_partnership' | 'non_profit' | 'partnership' | 'public_limited_company' | 'sole_proprietorship' | 'trust';
    export const StructureEnum = {
        CHARITY: 'charity' as StructureEnum,
        COMMUNITY_INTEREST_COMPANY: 'community_interest_company' as StructureEnum,
        CORPORATION: 'corporation' as StructureEnum,
        GOVERNMENT: 'government' as StructureEnum,
        LIMITED: 'limited' as StructureEnum,
        LIMITED_LIABILITY_COMPANY: 'limited_liability_company' as StructureEnum,
        LIMITED_LIABILITY_PARTNERSHIP: 'limited_liability_partnership' as StructureEnum,
        NON_PROFIT: 'non_profit' as StructureEnum,
        PARTNERSHIP: 'partnership' as StructureEnum,
        PUBLIC_LIMITED_COMPANY: 'public_limited_company' as StructureEnum,
        SOLE_PROPRIETORSHIP: 'sole_proprietorship' as StructureEnum,
        TRUST: 'trust' as StructureEnum
    };
}


